import { render } from "./LeaderboardMyNfts.vue?vue&type=template&id=e61dc6ae&scoped=true&ts=true"
import script from "./LeaderboardMyNfts.vue?vue&type=script&lang=ts"
export * from "./LeaderboardMyNfts.vue?vue&type=script&lang=ts"

import "./LeaderboardMyNfts.vue?vue&type=style&index=0&id=e61dc6ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61dc6ae"]])

export default __exports__